import { internalAnalyticsApi, type AnalyticsCategory } from '@/api/internal-analytics';

export const AnalyticsEvents = {
  shifts: {
    createdIndividualCalendar: 'shift_created_individual_calendar',
    createdIndividualDate: 'shift_created_individual_date',
    createdManualCalendar: 'shift_created_manual_calendar',
    createdManualPatientProfile: 'shift_created_manual_patient_profile',
    createdRecurring: 'shift_created_recurring',
    offered: 'shift_offered',
    offeringExistingEmail: 'shift_offering_existing_email',
    offeringPatientEmail: 'shift_offering_patient_email',
    stoppedCalendar: 'shift_stopped_calendar',
    stoppedCaregiverMenu: 'shift_stopped_caregiver_menu',
  },
  caregivers: {
    profileButtonClicked: 'caregiver_profile_button_clicked',
  },
  patients: {
    fileDownloaded: 'patient_file_downloaded',
    profileButtonClicked: 'patient_profile_button_clicked',
  },
  charges: {
    whatsappSent: 'charge_whatsapp_sent',
  },
  payments: {
    whatsappSent: 'payment_whatsapp_sent',
  },
} as const;

type SubjectInfo = { type: 'Shift' | 'Patient' | 'Caregiver'; id: number };

export function useAnalytics() {
  function trackEvent(
    category: AnalyticsCategory,
    eventType: string,
    properties?: Record<string, unknown>,
    subject?: SubjectInfo,
  ): void {
    internalAnalyticsApi.track({
      category,
      eventType,
      properties,
      subjectType: subject?.type,
      subjectId: subject?.id,
    });
  }

  function trackShiftEvent(
    eventType: string,
    props?: Record<string, unknown>,
    shiftId?: number,
  ): void {
    trackEvent('shifts', eventType, props, shiftId ? { type: 'Shift', id: shiftId } : undefined);
  }

  function trackPatientEvent(
    eventType: string,
    props?: Record<string, unknown>,
    patientId?: number,
  ): void {
    trackEvent(
      'patients',
      eventType,
      props,
      patientId ? { type: 'Patient', id: patientId } : undefined,
    );
  }

  function trackChargeEvent(eventType: string, props?: Record<string, unknown>): void {
    trackEvent('charges', eventType, props);
  }

  function trackPaymentEvent(eventType: string, props?: Record<string, unknown>): void {
    trackEvent('payments', eventType, props);
  }

  function trackCaregiverEvent(
    eventType: string,
    props?: Record<string, unknown>,
    caregiverId?: number,
  ): void {
    trackEvent(
      'caregivers',
      eventType,
      props,
      caregiverId ? { type: 'Caregiver', id: caregiverId } : undefined,
    );
  }

  return {
    trackEvent,
    trackShiftEvent,
    trackPatientEvent,
    trackChargeEvent,
    trackPaymentEvent,
    trackCaregiverEvent,
    AnalyticsEvents,
  };
}
